const brandNamesToBrand = {
  nib: "nib",
  gu: "GU Health",
  cignagu: "Cigna Australia by GU Health",
  apia: "Apia",
  suncorp: "Suncorp",
  ing: "ING Health Insurance",
  priceline: "Priceline Health Insurance",
  qantas: "Qantas Health Insurance",
  aami: "AAMI Health Insurance",
};

const brandDomainsToBrand = {
  kaos: {
    nib: "my.nib-cf-test.com",
    gu: "guhealth-test.com",
    cignagu: "cigna.guhealth-test.com",
    apia: "health-test.apia.com.au",
    suncorp: "health-test.suncorp.com.au",
    ing: "health-test.ing.com.au",
    priceline: "health-test.priceline.com.au",
    aami: "health-test.aami.com.au",
    qantas: "health.stage.insurance.qantas.com",
  },
  prod: {
    nib: "my.nib.com.au",
    gu: "guhealth.com.au",
    cignagu: "cigna.guhealth.com.au",
    apia: "health.apia.com.au",
    suncorp: "health.suncorp.com.au",
    ing: "health.ing.com.au",
    priceline: "health.priceline.com.au",
  },
};

export const brandNameForBrand = (brand: string): string => {
  return brandNamesToBrand[brand];
};

export const brandDomainsForBrand = (brand: string, stage: string): string => {
  return brandDomainsToBrand[stage.toLowerCase()][brand.toLowerCase()];
};
